"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_request_1 = __importDefault(require("@gerenciatd/next13.utils.request"));
/**
 * Implementa la clase PingCmsPage
 */
class PingCmsPage {
    /**
     */
    constructor({ context }) {
        /**
         * Crea el body necesario para enviar a CustoMetrics
         */
        function createBodyMessage() {
            try {
                const PROJECT_ID = process.env.NEXT_PUBLIC_PROJECT_ID;
                const VERSION_JS = process.env.NEXT_PUBLIC_VERSION_JS;
                let requestBody = {};
                let cdUrl = '';
                cdUrl =
                    window &&
                        window.location &&
                        window.location.host &&
                        window.location.pathname
                        ? window.location.host + window.location.pathname
                        : 'no_recuperable';
                requestBody = {
                    cdSource: 'PingCmsPages',
                    cdTimeStamp: new Date().toISOString(),
                    cdType: 'CMS-PAGE',
                    cdUrl,
                    ctzId: '',
                    ctzPageId: '',
                    ctzTemplateId: '',
                    phCode: '',
                    posCode: '',
                    status: '',
                    uiGAClientId: (context && context.clientIDs && context.clientIDs.ga) || '',
                    wbPageId: (context && context.clientIDs && context.clientIDs.pageId) || '',
                    wbSessionId: (context && context.clientIDs && context.clientIDs.sessId) || '',
                    webCode: '',
                    wsContext: typeof PROJECT_ID !== 'undefined' ? PROJECT_ID : null,
                    versionJS: typeof VERSION_JS !== 'undefined' ? VERSION_JS : null,
                    cdSegment: (context && context.pageSegment) || 'no_def',
                };
                return requestBody;
            }
            catch (err) {
                return null;
            }
        }
        /**
         * Envía la comunicacion con el servicio de CustoMetrics
         * @param {any} errorInfo (opcional) Información asociada al evento que se está sondando
         * @param {string} stackTrace (opcional) La traza del error
         * @param {Severity} severidad (opcional) severidad de la sonda
         * @return {undefined}
         */
        function sendInfoToCtzMetricsData() {
            const endPoint = 'https://europe-west1-mov-prod10.cloudfunctions.net/export-customizer-data-metrics';
            const headers = {
                timeout: 6000,
                'Content-Type': 'application/json',
            };
            const requestBody = createBodyMessage();
            if (requestBody) {
                const request = new next13_utils_request_1.default({
                    method: 'POST',
                    endpoint: endPoint,
                    data: requestBody,
                    beacon: true,
                    headers,
                });
                request
                    .makeRequest()
                    .then(() => { })
                    .catch(() => { });
            }
        }
        // eslint-disable-next-line func-names
        this.sendPingCmsPage = function () {
            sendInfoToCtzMetricsData();
        };
    }
}
exports.default = PingCmsPage;
//# sourceMappingURL=index.js.map